import LocaleStrings from 'Languages';

export default function(){
    return [
        {iconName:'dashboard', title:LocaleStrings.website_submenu_title1, description:LocaleStrings.website_submenu_description1},
        {iconName:'pages', title:LocaleStrings.website_submenu_title7, description:LocaleStrings.website_submenu_description7},
        {iconName:'menu', title:LocaleStrings.website_submenu_title8, description:LocaleStrings.website_submenu_description8},
        // {iconName:'seo', title:LocaleStrings.website_submenu_title9, description:LocaleStrings.website_submenu_description9},
        {iconName:'settings', title:LocaleStrings.website_submenu_title3, description:LocaleStrings.website_submenu_description3},
        // {iconName: 'wizard', title: LocaleStrings.website_submenu_title4, description: LocaleStrings.website_submenu_description4},
        // {iconName:'domains', title:LocaleStrings.website_submenu_title5, description:LocaleStrings.website_submenu_description5},
        // {iconName:'themes', title:LocaleStrings.website_submenu_title2, description:LocaleStrings.website_submenu_description2},
        // {iconName:'upgrade', title:LocaleStrings.website_submenu_title6, description:LocaleStrings.website_submenu_description6},
    ];
}